// extracted by mini-css-extract-plugin
export default {"dots":"BottomViews_dots__BQl2H","tile":"BottomViews_tile__G06HE","butt":"BottomViews_butt__RgPET","overlay":"BottomViews_overlay__gW+vV"};